import dynamic from 'next/dynamic'

export const PhoneScroller = dynamic(() => import('./phone-scroller'))
